'use client';

import { Fragment } from 'react';
import type { ReactNode } from 'react';
import s from '@/styles/authShell.module.css';
import { Brand } from '@/components/ui';

export interface AuthStat {
  num: string;
  label: string;
}

/** Scaffold dua kolom auth: panel brand (dekoratif, sembunyi di mobile) + kartu form. */
export function AuthShell({
  headline,
  sub,
  stats,
  children,
}: {
  headline: string;
  sub: string;
  stats?: AuthStat[];
  children: ReactNode;
}) {
  return (
    <div className={s.split}>
      <aside className={s.brand} aria-hidden="true">
        <Brand nameColor="#fff" />
        <div className={s.brandBody}>
          <h2 className="mx-display" style={{ marginBottom: 'var(--mx-sp-4)' }}>{headline}</h2>
          <p className={s.brandCopy}>{sub}</p>
          {stats && stats.length > 0 && (
            <div className={s.stats}>
              {stats.map((st, i) => (
                <Fragment key={st.label}>
                  {i > 0 && <div className={s.statDiv} />}
                  <div>
                    <div className={s.statNum}>{st.num}</div>
                    <div className={s.statLabel}>{st.label}</div>
                  </div>
                </Fragment>
              ))}
            </div>
          )}
        </div>
      </aside>

      <main className={s.form}>
        <div className={s.card}>{children}</div>
      </main>
    </div>
  );
}

/** Pemisah "atau email" dengan garis di kiri-kanan. */
export function AuthDivider({ children }: { children: ReactNode }) {
  return (
    <div className={s.divider}>
      <span className="mx-caption">{children}</span>
    </div>
  );
}
